import {useAuthUserStore} from "@/stores/auth";

export default {
    index(academyUuid) {
        return useAuthUserStore().getApiClient.get('/academy/brandname', {
            params: {
                academy_uuid: academyUuid
            }
        })
    },

    update(academyUuid, data)
    {
        return useAuthUserStore().getApiClient.put('/academy/brandname', data, {
            params: {
                academy_uuid: academyUuid
            }
        })
    }
}